import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { CatharsisMegaStoreSymbol, MegaStoreWithSubscriptions } from '@wix/thunderbolt-catharsis'
import { getStore, storeFactory } from './stores'
import { AppMaterializer, MaterializedStore, StateRefs } from './materializedStore'

import { CompRefs } from './compRefs'
import { SuspendedComps } from './suspendedComps'
import { CompEventsRegistrar } from './compEventsRegistrar'
import { CompsLifeCycle } from './compsLifeCycle'
import type {
	AppStructure,
	PropsMap,
	CompActions,
	IStructureStore,
	IPropsStore,
	ICompActionsStore,
	IRendererPropsExtender,
	ICompsLifeCycle,
	ICompEventsRegistrar,
	IStylesStore,
	StylesMap,
	IStateRefsStore,
	IMaterializedStore,
} from '@wix/thunderbolt-symbols'
import {
	Structure,
	Props,
	CompActionsSym,
	RendererPropsExtenderSym,
	CompsLifeCycleSym,
	CompEventsRegistrarSym,
	CompRefAPISym,
	StylesStoreSymbol,
	BeckyPropsInitialStoreSym,
	StateRefsStoreSymbol,
	MaterializedStoreSymbol,
	AppMaterializerSymbol,
	SuspendedCompsSym,
} from '@wix/thunderbolt-symbols'
import { ComponentsStoreSymbol } from 'feature-components'
import type { Materializer } from '@wix/thunderbolt-types'

export { Structure, getStore }

const rendererPropsExtender = withDependencies(
	[Structure, Props, StylesStoreSymbol, CompsLifeCycleSym, CompEventsRegistrarSym, StateRefsStoreSymbol],
	(
		structureStore: IStructureStore,
		propsStore: IPropsStore,
		stylesStore: IStylesStore,
		compsLifeCycle: ICompsLifeCycle,
		compEventsRegistrar: ICompEventsRegistrar,
		stateRefs: IStateRefsStore
	): IRendererPropsExtender => {
		return {
			async extendRendererProps() {
				return {
					styles: stylesStore,
					structure: structureStore,
					props: propsStore,
					compsLifeCycle,
					compEventsRegistrar,
					stateRefs,
				}
			},
		}
	}
)

export const siteCommon: ContainerModuleLoader = (bind) => {
	// Serializable
	bind<Materializer>(AppMaterializerSymbol).to(AppMaterializer)
	bind<IMaterializedStore>(MaterializedStoreSymbol).to(MaterializedStore)

	bind<IStructureStore>(Structure).to(storeFactory<AppStructure>())
	bind<IStateRefsStore>(StateRefsStoreSymbol).to(StateRefs)
	bind<IPropsStore>(Props).to(storeFactory<PropsMap>())
	// this store is responsible for storing component onload styles as well as platform style overrides
	bind<IStylesStore>(StylesStoreSymbol).to(storeFactory<StylesMap>())
	bind(ComponentsStoreSymbol).to(storeFactory())

	// Not Serializable
	bind<ICompActionsStore>(CompActionsSym).to(storeFactory<CompActions>())

	bind(CompRefAPISym).to(CompRefs)
	bind(CompEventsRegistrarSym).to(CompEventsRegistrar)
	bind(CompsLifeCycleSym).to(CompsLifeCycle)
	bind<IRendererPropsExtender>(RendererPropsExtenderSym).to(rendererPropsExtender)
	bind(SuspendedCompsSym, RendererPropsExtenderSym).to(SuspendedComps)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(CatharsisMegaStoreSymbol).toConstantValue(new MegaStoreWithSubscriptions())

	siteCommon(bind)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind<IPropsStore>(BeckyPropsInitialStoreSym).to(storeFactory<PropsMap>())

	siteCommon(bind)
}
